import styled from 'styled-components';
import { Droppable } from '@hello-pangea/dnd';
import { themeGet } from '@styled-system/theme-get';
import { useSelector, useDispatch } from 'react-redux';

import { CreateDigestButton } from './CreateDigestButton.jsx';
import { NewTilesDigestModal } from '../NewTilesDigestModal.jsx';
import { setDragAndDropContext } from '../../../../lib/redux/actions.jsx';

const Wrapper = styled.div`
  width: 100%;
  height: 301px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
`;

const CreateDigestBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CreateDigest = ({ addTileDigest, initialDate, month }) => {
  const dndContext = useSelector(state => state.dndContext);
  const dispatch = useDispatch();

  const onCancel = () => {
    const { tileId } = dndContext.draggedToNewDigest;

    if (tileId) {
      document.querySelector(`#single-tile-${tileId}`).style.display = 'block';
      dispatch(
        setDragAndDropContext({ ...dndContext, draggedToNewDigest: null }),
      );
    }
  };

  return (
    <Droppable droppableId={`new-digest-${month}`} direction="horizontal">
      {provided => (
        <Wrapper ref={provided.innerRef} {...provided.droppableProps}>
          <NewTilesDigestModal
            initialDate={initialDate}
            onConfirm={addTileDigest}
            onCancel={onCancel}
          >
            <div className="js-new-digest-button icon">
              <CreateDigestBox>
                {provided.placeholder}
                <CreateDigestButton
                  position="absolute"
                  addTileDigest={addTileDigest}
                  smallCalendar={false}
                  initialDate={initialDate}
                  shouldBreak={true}
                />
              </CreateDigestBox>
            </div>
          </NewTilesDigestModal>
        </Wrapper>
      )}
    </Droppable>
  );
};
